/* MOS order quantity rules (minimum + multiples) for retail customers.
   Data: sections/mos-qty-rules.liquid, from product fields custom.min_order_qty and custom.order_qty_step.
   1. Product page: quantity box starts at the minimum and the +/- buttons step by the multiple.
   2. Cart page and drawer: the same min/step on each line's quantity box.
   3. Safety net: after ANY add/change/update to the cart (product page, search cards, quick add,
      cart page, apps), re-read the cart and fix any line that breaks its rule, then tell the customer.
   B2B customers also get Shopify's native catalog rules; both use the same numbers. */
(function () {
	"use strict";
	if (window.__mosQty) return;
	var API = (window.__mosQty = { version: 2, corrections: 0, checks: 0 });
	var SEC = "mos-qty-rules";
	var RX = /\/cart\/(add|change|update)(\.js)?(\?|$)/;
	var origFetch = window.fetch.bind(window);
	var last = {};
	var byVariant = {};
	var byLine = {};
	var busy = false;
	var pending = false;
	var timer = null;

	function root() {
		return (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";
	}
	function norm(min, step) {
		min = parseInt(min, 10) || 0;
		step = parseInt(step, 10) || 0;
		if (!min && !step) return null;
		step = step || 1;
		min = Math.max(min || step, 1);
		if (min <= 1 && step <= 1) return null;
		return { min: min, step: step };
	}
	function up(q, r) {
		return q <= r.min ? r.min : r.min + Math.ceil((q - r.min) / r.step) * r.step;
	}
	function down(q, r) {
		return q <= r.min ? r.min : r.min + Math.floor((q - r.min) / r.step) * r.step;
	}
	function ok(q, r) {
		return q >= r.min && (q - r.min) % r.step === 0;
	}
	function ruleText(r) {
		return r.step > 1
			? "Minimum order " + r.min + ", then in multiples of " + r.step + "."
			: "Minimum order " + r.min + ".";
	}
	API.math = { norm: norm, up: up, down: down, ok: ok };

	function parseHtml(html) {
		var d = document.createElement("div");
		d.innerHTML = html;
		var s = d.querySelector("script[data-mos-qty-rules]");
		try {
			return s ? JSON.parse(s.textContent) : null;
		} catch (e) {
			return null;
		}
	}
	function readInline() {
		var s = document.querySelector("script[data-mos-qty-rules]");
		try {
			return s ? JSON.parse(s.textContent) : null;
		} catch (e) {
			return null;
		}
	}
	function getState() {
		/* No Accept: application/json here - on /cart that returns cart.js instead of the sections. */
		return origFetch(root() + "cart?sections=" + SEC, { credentials: "same-origin" })
			.then(function (r) {
				return r.ok ? r.json() : null;
			})
			.then(function (j) {
				return j && j[SEC] ? parseHtml(j[SEC]) : null;
			})
			.catch(function () {
				return null;
			});
	}
	function remember(st) {
		last = {};
		byVariant = {};
		byLine = {};
		((st && st.cart) || []).forEach(function (it) {
			last[it.v] = (last[it.v] || 0) + it.q;
			var r = norm(it.min, it.step);
			if (r) {
				byVariant[it.v] = r;
				byLine[it.line] = r;
			}
		});
		applyCartInputs();
	}

	function toast(text) {
		if (!document.body) return;
		var el = document.getElementById("mos-qty-toast");
		if (!el) {
			el = document.createElement("div");
			el.id = "mos-qty-toast";
			el.setAttribute("role", "status");
			el.setAttribute("aria-live", "polite");
			document.body.appendChild(el);
		}
		el.textContent = text;
		requestAnimationFrame(function () {
			el.classList.add("is-on");
		});
		clearTimeout(el._t);
		el._t = setTimeout(function () {
			el.classList.remove("is-on");
		}, 7000);
	}

	function replaceSection(html, selector, targets) {
		if (!html) return;
		var src = new DOMParser().parseFromString(html, "text/html").querySelector(selector);
		if (!src) return;
		document.querySelectorAll(targets).forEach(function (el) {
			el.innerHTML = src.innerHTML;
		});
	}
	function refreshUI(openDrawer) {
		if (/\/cart\/?$/.test(location.pathname)) {
			location.reload();
			return Promise.resolve();
		}
		var drawer = document.querySelector("cart-drawer");
		return origFetch(root() + "cart?sections=cart-drawer,cart-icon-bubble", { credentials: "same-origin" })
			.then(function (r) {
				return r.json();
			})
			.then(function (sections) {
				if (drawer && openDrawer && typeof drawer.renderContents === "function") {
					drawer.renderContents({ sections: sections });
					return;
				}
				replaceSection(sections["cart-drawer"], "#CartDrawer", "#CartDrawer");
				replaceSection(sections["cart-icon-bubble"], ".shopify-section", "#cart-icon-bubble");
				var ov = drawer && drawer.querySelector("#CartDrawer-Overlay");
				if (ov && typeof drawer.close === "function") ov.addEventListener("click", drawer.close.bind(drawer, false));
			})
			.catch(function () {});
	}

	function changeLine(line, qty) {
		return origFetch(root() + "cart/change.js", {
			method: "POST",
			credentials: "same-origin",
			headers: { "Content-Type": "application/json", Accept: "application/json" },
			body: JSON.stringify({ line: line, quantity: qty }),
		});
	}

	function check(openDrawer) {
		if (busy) {
			pending = true;
			return;
		}
		busy = true;
		API.checks++;
		getState()
			.then(function (st) {
				if (!st) return;
				var fixes = [];
				st.cart.forEach(function (it) {
					var r = norm(it.min, it.step);
					if (!r || ok(it.q, r)) return;
					var prev = last[it.v];
					var target = prev !== undefined && it.q < prev ? down(it.q, r) : up(it.q, r);
					fixes.push({ line: it.line, q: target, t: it.t, r: r });
				});
				if (!fixes.length) {
					remember(st);
					return;
				}
				var chain = Promise.resolve();
				fixes.forEach(function (f) {
					chain = chain.then(function () {
						return changeLine(f.line, f.q);
					});
				});
				return chain
					.then(getState)
					.then(function (st2) {
						API.corrections += fixes.length;
						remember(st2 || st);
						var f = fixes[0];
						var text = f.t + ": " + ruleText(f.r) + " Quantity set to " + f.q + ".";
						if (fixes.length > 1) text += " (" + fixes.length + " items adjusted.)";
						if (/\/cart\/?$/.test(location.pathname)) {
							try {
								sessionStorage.setItem("mosQtyToast", text);
							} catch (e) {}
						} else {
							toast(text);
						}
						return refreshUI(openDrawer);
					});
			})
			.catch(function () {})
			.then(function () {
				busy = false;
				if (pending) {
					pending = false;
					check(openDrawer);
				}
			});
	}
	function schedule(isAdd) {
		clearTimeout(timer);
		timer = setTimeout(function () {
			var drawer = document.querySelector("cart-drawer");
			check(isAdd || !!(drawer && drawer.classList.contains("active")));
		}, 250);
	}

	/* Watch every cart write, whichever script makes it. */
	window.fetch = function (input, init) {
		var url = typeof input === "string" ? input : (input && input.url) || String(input || "");
		var p = origFetch(input, init);
		if (RX.test(url)) {
			var isAdd = /\/cart\/add/.test(url);
			p.then(
				function () {
					schedule(isAdd);
				},
				function () {}
			);
		}
		return p;
	};
	var xOpen = XMLHttpRequest.prototype.open;
	var xSend = XMLHttpRequest.prototype.send;
	XMLHttpRequest.prototype.open = function (m, u) {
		this.__mosCart = RX.test(String(u || ""));
		this.__mosAdd = /\/cart\/add/.test(String(u || ""));
		return xOpen.apply(this, arguments);
	};
	XMLHttpRequest.prototype.send = function () {
		if (this.__mosCart) {
			var add = this.__mosAdd;
			this.addEventListener("loadend", function () {
				schedule(add);
			});
		}
		return xSend.apply(this, arguments);
	};

	/* Quick pick buttons: "Label: quantity" lines from custom.qty_presets, plus the minimum. */
	function parsePresets(list, r) {
		var out = [];
		(Array.isArray(list) ? list : []).forEach(function (line) {
			var i = String(line).lastIndexOf(":");
			if (i < 1) return;
			var q = parseInt(String(line).slice(i + 1), 10);
			var label = String(line).slice(0, i).trim();
			if (!q || !label) return;
			if (!ok(q, r)) q = up(q, r);
			out.push({ q: q, label: label });
		});
		return out;
	}
	function buildPicks(list, r, inp) {
		var presets = parsePresets(list, r);
		if (!presets.length) return null;
		presets.unshift({ q: r.min, label: "Minimum" });
		var wrap = document.createElement("div");
		wrap.className = "mos-qty-picks";
		var lab = document.createElement("span");
		lab.className = "mos-qty-picks__label";
		lab.textContent = "Quick pick:";
		wrap.appendChild(lab);
		var btns = [];
		function mark() {
			var v = parseInt(inp.value, 10) || 0;
			btns.forEach(function (b) {
				var on = parseInt(b.getAttribute("data-q"), 10) === v;
				b.classList.toggle("is-active", on);
				b.setAttribute("aria-pressed", on ? "true" : "false");
			});
		}
		presets.forEach(function (p) {
			var b = document.createElement("button");
			b.type = "button";
			b.setAttribute("data-q", p.q);
			b.appendChild(document.createTextNode(p.q + " "));
			var s = document.createElement("span");
			s.textContent = "\u00b7 " + p.label;
			b.appendChild(s);
			b.addEventListener("click", function () {
				inp.value = p.q;
				inp.setAttribute("value", p.q);
				inp.dispatchEvent(new Event("change", { bubbles: true }));
				snapPdp(inp, r);
				mark();
			});
			btns.push(b);
			wrap.appendChild(b);
		});
		["change", "input", "blur"].forEach(function (ev) {
			inp.addEventListener(ev, function () { setTimeout(mark, 0); });
		});
		var qi = inp.closest("quantity-input");
		if (qi) qi.addEventListener("click", function () { setTimeout(mark, 10); });
		mark();
		API.picks = presets;
		return wrap;
	}

	/* Product page quantity box. */
	function snapPdp(inp, r) {
		var v = parseInt(inp.value, 10) || 0;
		if (!ok(v, r)) inp.value = up(v, r);
		var qi = inp.closest("quantity-input");
		var minus = qi && qi.querySelector('button[name="minus"]');
		if (minus) minus.classList.toggle("disabled", parseInt(inp.value, 10) <= r.min);
	}
	function applyPdp(p) {
		var r = p && norm(p.min, p.step);
		if (!r) return;
		document.querySelectorAll('input.quantity__input[name="quantity"], form[action*="/cart/add"] input[name="quantity"]').forEach(function (inp) {
			if (inp.closest("cart-drawer, cart-items, .cart-item")) return;
			inp.min = r.min;
			inp.step = r.step;
			inp.setAttribute("data-min", r.min);
			var v = parseInt(inp.value, 10) || 0;
			if (!ok(v, r)) inp.value = up(v, r);
			inp.setAttribute("value", inp.value);
			snapPdp(inp, r);
			if (!inp.__mosQty) {
				inp.__mosQty = true;
				["change", "blur"].forEach(function (ev) {
					inp.addEventListener(ev, function () {
						snapPdp(inp, r);
					});
				});
				var qi = inp.closest("quantity-input");
				if (qi)
					qi.addEventListener("click", function () {
						setTimeout(function () {
							snapPdp(inp, r);
						}, 0);
					});
			}
			var anchor = inp.closest(".product-form__buttons") || inp.closest(".product-form__quantity") || inp.closest("quantity-input");
			if (anchor && anchor.parentNode && !anchor.parentNode.querySelector(".mos-qty-note")) {
				var n = document.createElement("p");
				n.className = "mos-qty-note";
				n.textContent = ruleText(r);
				anchor.parentNode.insertBefore(n, anchor);
				var picks = buildPicks(p.presets, r, inp);
				if (picks) anchor.parentNode.insertBefore(picks, anchor);
			}
		});
	}

	/* Cart page and drawer quantity boxes. */
	function applyCartInputs() {
		document.querySelectorAll('cart-items input.quantity__input, cart-drawer-items input.quantity__input, .cart-item input.quantity__input').forEach(function (inp) {
			var row = inp.closest("[data-variant-id]");
			var r = (row && byVariant[row.getAttribute("data-variant-id")]) || (inp.dataset.index && byLine[inp.dataset.index]);
			if (!r) return;
			if (String(inp.min) !== String(r.min)) inp.min = r.min;
			if (String(inp.step) !== String(r.step)) inp.step = r.step;
			var qi = inp.closest("quantity-input");
			var minus = qi && qi.querySelector('button[name="minus"]');
			if (minus) minus.classList.toggle("disabled", (parseInt(inp.value, 10) || 0) <= r.min);
		});
	}
	var moTimer = null;
	function observe() {
		if (!window.MutationObserver || !document.body) return;
		new MutationObserver(function () {
			clearTimeout(moTimer);
			moTimer = setTimeout(applyCartInputs, 60);
		}).observe(document.body, { childList: true, subtree: true });
	}

	function start() {
		var st = readInline();
		if (st) {
			remember(st);
			applyPdp(st.product);
			var bad = st.cart.some(function (it) {
				var r = norm(it.min, it.step);
				return r && !ok(it.q, r);
			});
			if (bad) check(false);
		}
		observe();
		try {
			var t = sessionStorage.getItem("mosQtyToast");
			if (t) {
				sessionStorage.removeItem("mosQtyToast");
				toast(t);
			}
		} catch (e) {}
	}
	if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", start);
	else start();
})();
